var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F47451",
    d: "M7 0a6.004 6.004 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6A5.955 5.955 0 0 1 7 12a5.965 5.965 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.014 6.014 0 0 1 7 0Zm-.563 2.813v3.492l.235.164 2.25 1.5.469.328.632-.938-.468-.328L7.563 5.72V2.25H6.438v.563Z"
  })));
};
export default SvgClock;